<template>
  <div id="app">
    <router-view />
    <AppNotifications />
    <AppConfirmDialog />
    <AvisoNuevaVersion />
  </div>
</template>

<script>
import AppNotifications from '@/components/AppNotifications.vue'
import AppConfirmDialog from '@/components/AppConfirmDialog.vue'
import AvisoNuevaVersion from '@/components/AvisoNuevaVersion.vue'

export default {
  name: 'App',
  components: {
    AppNotifications,
    AppConfirmDialog,
    AvisoNuevaVersion
  }
}
</script>

<style>
/* Estilos globales, si tienes alguno */
</style>

